import React, { useEffect, useState } from 'react'
import { Text, View } from 'react-native'
import FetchingDataScreen from '../../../components/fetchingDataScreen'
import { getDataLoadingScreen } from '../../../js/getDataLoadingScreen'
import { CLICKED, EXIT, INITIAL_LOADER_SCREEN, TABLE_RESERVATION_CATEGORY } from '../../../config/Constant'
import InfoPopupModal from '../../../components/infoPopupModal'
import { useDispatch, useSelector } from 'react-redux'
import { setGoHome, setShowLoginModal } from '../../../Redux/Reducers/appConfigReducer'
import { calculateTimeDifference, generateToken, toBool } from '../../../utils/Helper'
import { sendAnalytics } from '../../../Redux/Actions/analyticsAction'
import { createRestaurantReservationV2, get7roomsRestaurantReservationData, getMyReservationData, searchDailyProgrammeData, searchVenueAvailability, updateRestaurantReservationV2 } from '../../../Redux/Actions/tableReservationAction'
import VenueList from './venueList'
import MyReservations from './myReservations'
import ReservationDetails from './reservationDetails'
import { resetReservationData } from '../../../Redux/Reducers/tableReservationReducer'
import ReservationAvailability from './reservationAvailability'
import ReservationCreatePage from './reservationCreatePage'
import AsyncStorage from '@react-native-async-storage/async-storage'
import ReservationSuccess from './reservationSuccess'
import ReservationUpdate from './reservationUpdate'
import { useTranslation } from 'react-i18next'
import { useCssStyle } from '../../../customHook/getCssStyle'
import ReservationsAskDailyProgram from './reservationsAskDailyProgram'

const SevenRooms = () => {
    const dispatch = useDispatch();
    const getStyles = useCssStyle();

    const { currentWidget, webAppWidgetsInfo } = useSelector(state => state.deviceConfigSlice);
    const { isLoggedIn } = useSelector((state) => state.appConfigSlice);
    const [tableReservationSessionToken, setTableReservationSessionToken] = useState(generateToken("tablereservation_"));
    const [widgetLaunchTime, setWidgetLaunchTime] = useState(() => new Date());

    const { allowWalkInGuestRestaurantBooking } = webAppWidgetsInfo.appConfigs.restaurantReservationConfigs;

    const { allVenues, myReservations } = useSelector(state => state.tableReservationSlice);
    const { t } = useTranslation();

    const [currentPage, setCurrentPage] = useState(0);

    const [selectedVenue, setSelectedVenue] = useState();
    const [preferredVenueDetails, sePreferredVenueDetails] = useState({})
    const [askDailyProgramAck, setAskDailyProgramAck] = useState({
        status: false,
        message: ""
    });
    const [askDailyProgramAckAvailability, setAskDailyProgramAckAvailability] = useState({
        visible: false,
        data: []
    })

    const [venueAvailability, setVenueAvailability] = useState([]);
    const [dailyProgrammeData, setDailyProgrammeData] = useState([]);

    const [editReservation, setEditReservation] = useState(null);

    const [initialLoading, setInitialLoading] = useState(true);
    const [loaderState, setLoaderState] = useState({
        showLoader: "",
        loaderMessage: ""
    });

    const [fetchApiError, setFetchApiError] = useState({
        errorStatus: false,
        errorMessageTitle: "",
        errorMessage: "",
        onContinueFunc: null,
        primaryBtnLabel: "",
        onCloseFunc: null,
        secondaryBtnLabel: ""
    });

    const updateFetchApiError = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel, errorMessageTitle) => {
        setFetchApiError({
            errorStatus,
            errorMessageTitle: errorMessageTitle ? errorMessageTitle : "",
            errorMessage: errorStatus ? errorMessage : "",
            onContinueFunc: errorStatus ? onContinueFunc : null,
            primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
            onCloseFunc: errorStatus ? onCloseFunc : null,
            secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
        });
    }

    const updateLoaderState = (loading, message) => {
        setLoaderState({
            showLoader: loading,
            loaderMessage: message
        })
    }
    const updateAskDailyProgramAck = (status, message) => {
        setAskDailyProgramAck({
            status,
            message
        })
    }

    const updateAskDailyProgramAckAvailability = (visible, data) => {
        setAskDailyProgramAckAvailability({
            visible,
            data
        })
    }

    const handleSelectVenueDetailsNext = async (selectedVenueDetails={}) => {
        updateLoaderState(true, "Fetching availability...");

        sePreferredVenueDetails({...preferredVenueDetails, ...selectedVenueDetails});
        
        try {
            let searchAvailabilityPayload = {
                "venueId": selectedVenue?.id,
                "guestCount" : selectedVenueDetails.guestCount,
                "date" : selectedVenueDetails.date,
                "endTime" : selectedVenueDetails.endTime,
                "startTime" : selectedVenueDetails.startTime,
            }
            let dailyProgrammePayload = {
                "venueId": selectedVenue?.id,
                "date": selectedVenueDetails.date
            }

            const searchDaiyProgram = async () => {
                const { status, data } = await dispatch(searchDailyProgrammeData(dailyProgrammePayload));

                if(!status){
                    dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH DAILY PROGRAMME - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": data }));
                    return
                }
                setDailyProgrammeData(data || []);

                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH DAILY PROGRAMME - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));
            };

            searchDaiyProgram();
            
            const { status, data } = await dispatch(searchVenueAvailability(searchAvailabilityPayload));

            if(!status){
                updateLoaderState(false);
                updateFetchApiError(true, data);

                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH Venue Availability - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": data }));
                return
            }
            setVenueAvailability(data || []);
            handleNext();

            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH Venue Availability - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));
        } catch (error) {
            updateFetchApiError(true, error?.message || "Something went wrong");
            
        } finally {
            updateLoaderState(false);
        }
    }

    const handleCreateBooking = async (requestVenueDetails) => {
        sePreferredVenueDetails((prev) => ({...prev, ...requestVenueDetails}));

        updateLoaderState(true, "Creating Reservation...");

        try {
            let requestPayload = {
                "venueId" : selectedVenue?.id,
                "firstName" : requestVenueDetails.firstName,
                "lastName" : requestVenueDetails.lastName,
                "email" : requestVenueDetails.email,
                "phoneNumber": requestVenueDetails.phoneNumber,
                "guestComment" : requestVenueDetails.guestComment,
                "guestCount" : preferredVenueDetails.guestCount,
                "date" : preferredVenueDetails.date,
                "reservationTime" : preferredVenueDetails.reservationTime,
                "shiftCategory" : preferredVenueDetails.shiftCategory,
                "dailyProgramAck" : preferredVenueDetails.dailyProgramAck || false
            }
            

            const { status, statusCode, data } = await dispatch(createRestaurantReservationV2(requestPayload));

            if(!status){
                updateFetchApiError(true, data || "Something went wrong");
                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "CREATE RESERVATION - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": data || "Something went wrong" }));
                updateLoaderState(false)
                return
            }

            if(statusCode == 409){
                updateAskDailyProgramAck(true, data);
                updateFetchApiError(
                    true,
                    data,
                    handleDailyProgramAck,
                    null,
                    null,
                    null,
                    t('reservations.dailyProgramAck.heading1'),
                    t('reservations.dailyProgramAck.program_ack_question')
                )
            } else {
                await AsyncStorage.setItem("resReservationClientId", data);
                
                sePreferredVenueDetails({});
                handleNext();

            }
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "CREATE RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));

        } catch (error) {
            updateFetchApiError(true, error?.message || "Something went wrong");
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "CREATE RESERVATION - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": error?.message || "Something went wrong" }));
        } finally {
            updateLoaderState(false)
        }
    }

    const handleUpdateReservation = async (payload) => {
        // Update reservation
        updateLoaderState(true, "Updating Reservation...");
        try {
            const { status, message } = await dispatch(updateRestaurantReservationV2(payload));

            if(!status){
                updateFetchApiError(true, message);
                updateLoaderState(false);

                dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "UPDATE RESERVATION - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": message }));
                return
            }

            updateFetchApiError(true, t('reservations.success.successful_res_update'), handleNext, t('reservations.success.okay'), null, null, t('reservations.success.thank_you'));

            setEditReservation(null);

            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "UPDATE RESERVATION - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));
        } catch (error) {
            updateFetchApiError(true, error?.message);
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "UPDATE RESERVATION - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": error?.message }));
                return
        } finally {
            updateLoaderState(false)
        }
    }

    const handleDailyProgramAck = () => {
        sePreferredVenueDetails({...preferredVenueDetails, dailyProgramAck: true});

        handleCreateBooking({...preferredVenueDetails, dailyProgramAck: true});
    }

    const handleAvailabilityPageNext = (selectedTimeData) => {
        const matchingDailyProgrammes = dailyProgrammeData.filter((dailyProgramme) => 
            (dailyProgramme.shift_categories_display && selectedTimeData.shiftCategory) && dailyProgramme.shift_categories_display.toLowerCase() == selectedTimeData.shiftCategory?.toLowerCase()
        );

        if(matchingDailyProgrammes.length > 0 && !selectedTimeData.dailyProgramAck){
                updateAskDailyProgramAckAvailability(true, [...matchingDailyProgrammes])
                return
        }

        handleNext()
    }

    const handleEditReservation = (reservation) => {
        setEditReservation(reservation);

        setCurrentPage(6);
    }

    const handleRefreshMyReservations = () => {
        dispatch(getMyReservationData(getMyReservationDataCallback));
    }


    const getCurrentPage = () => {
        switch (currentPage) {
            case 0:
                return <VenueList handleNext={handleNext} handleGoBack={handleGoBack} />
            case 1:
                return <MyReservations selectedVenue={selectedVenue} tableReservationSessionToken={tableReservationSessionToken} setEditReservation={handleEditReservation} handleNext={handleNext} handleGoBack={handleGoBack} handleRefreshMyReservations={handleRefreshMyReservations}/>
            case 2:
                return <ReservationDetails selectedVenue={selectedVenue} preferredVenueDetails={preferredVenueDetails} handleNext={handleSelectVenueDetailsNext} handleGoBack={handleGoBack} />
            case 3:
                return <ReservationAvailability
                    preferredVenueDetails={preferredVenueDetails}
                    sePreferredVenueDetails={sePreferredVenueDetails}
                    venueAvailability={venueAvailability}
                    dailyProgrammeData={dailyProgrammeData}
                    handleNext={handleAvailabilityPageNext} 
                    handleGoBack={handleGoBack}
                />
            case 4:
                return <ReservationCreatePage
                    selectedVenue={selectedVenue} 
                    preferredVenueDetails={preferredVenueDetails} 
                    venueAvailability={venueAvailability}
                    dailyProgrammeData={dailyProgrammeData}
                    handleNext={handleCreateBooking} 
                    handleGoBack={handleGoBack}
                />
            case 5:
                return <ReservationSuccess handleNext={handleNext} handleGoBack={handleGoBack} />
            case 6:
                return <ReservationUpdate editReservation={editReservation} setEditReservation={setEditReservation} handleNext={handleUpdateReservation} handleGoBack={handleGoBack} />
            default:
                return null
        }
    }

    const handleNext = (data) => {
        switch(currentPage){
            case 0:
                setSelectedVenue(data);
                handleRefreshMyReservations();
                setCurrentPage(1);
                return
            case 5:
            case 6:
                setTimeout(() => handleRefreshMyReservations(), 3000)
                updateFetchApiError(false)
                setCurrentPage(1);
                return
            default:
                setCurrentPage(currentPage+1);
                return
        }
    }

    const getMyReservationDataCallback = (status, message) => {
        if(!status){
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH RESERVATION DETAILS - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": message }));
            return
        }

        dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH RESERVATION DETAILS - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));
    }
    const get7roomsRestaurantReservationDataCallback = (status, message) => {
        if(!status){
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH RESERVATION DATA - ERROR", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage, "errorMessage": message }));
            return
        }

        dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, "FETCH RESERVATION DATA - SUCCESS", { "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }));
    }



    const handleGoBack = () => {
        switch(currentPage){
            case 5:
            case 6:
                setCurrentPage(1);
                return
            default:
                if((currentPage == 0) || (currentPage == 1 && allVenues?.allVenueData?.length == 1)){
                    dispatch(setGoHome(true));
                    return
                }
                setCurrentPage(currentPage - 1);
                return
        }
    }

    useEffect(() => {
        if(!allVenues?.loading){
            setInitialLoading(false);
            updateLoaderState(false);

            if(!allVenues?.allVenueData?.length) {
                updateFetchApiError(
                    true, 
                    allVenues?.error || "Something went wrong",
                    handleGoBack
                )
            }
            if(allVenues?.allVenueData?.length == 1){
                setSelectedVenue(allVenues?.allVenueData[0]);
                setCurrentPage(1);
                handleRefreshMyReservations()
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allVenues?.loading])

    const initialise = () => {
        dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, CLICKED, {  "element": "widget", "widgetSessionId": tableReservationSessionToken, "pageName": currentPage }))

        dispatch(get7roomsRestaurantReservationData(get7roomsRestaurantReservationDataCallback, currentWidget?.venueLocationId));
    };


    useEffect(() => {
        if(toBool(allowWalkInGuestRestaurantBooking) || isLoggedIn){
            initialise();
        } else if(!isLoggedIn){
            dispatch(setShowLoginModal(true));
            dispatch(setGoHome(true));
        }


        return () => {
            dispatch(resetReservationData());

            const widgetCloseTime = new Date;
            const widgetCloseDuration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second');
            dispatch(sendAnalytics(TABLE_RESERVATION_CATEGORY, EXIT, { element: "widget", "duration": widgetCloseDuration, widgetSessionId: tableReservationSessionToken }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allowWalkInGuestRestaurantBooking, isLoggedIn])


    
    return (
        <>
            {getCurrentPage()}

            {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
            {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}

            {askDailyProgramAck?.status && 
                <InfoPopupModal 
                    title={t('reservations.dailyProgramAck.heading1')}
                    subtitle={askDailyProgramAck?.message || ""}
                    onContinue={handleDailyProgramAck}
                    primaryBtnLabel={"Continue"} 
                    onClose={() => updateAskDailyProgramAck(false)}
                    secondaryBtnLabel={"Close"}
                    OnRequestClose={() => updateAskDailyProgramAck(false)}
                >
                    <Text style={getStyles(["sevenRoomsDailyProgramAckResponseMessage"])} id='sevenRoomsDailyProgramAckResponseMessage'>{t('reservations.dailyProgramAck.program_ack_question')}</Text>
                </InfoPopupModal>
            }
            {askDailyProgramAckAvailability.visible && <ReservationsAskDailyProgram 
                askDailyProgramAckAvailability={askDailyProgramAckAvailability}
                updateAskDailyProgramAckAvailability={updateAskDailyProgramAckAvailability}
                handleNext={() => {
                    updateAskDailyProgramAckAvailability(false)
                    handleNext();
                }}
                handleGoBack={() => updateAskDailyProgramAckAvailability(false)}
            />}


            {fetchApiError.errorStatus && 
                <InfoPopupModal
                    title={fetchApiError.errorMessageTitle}
                    subtitle={fetchApiError.errorMessage} 
                    onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
                    primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
                    onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
                    secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
                    OnRequestClose={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
            />}

        </>
    )
}

export default SevenRooms
